module.exports = __webpack_public_path__ + "img/CPO.4668efe7.png";